import * as React from "react";
import SuperAdminSidebar from "../../superAdmin/components/sidebar/SuperAdminSidebar";

const SideMenu = () => {

  return (
    <SuperAdminSidebar />
  );
}

export default SideMenu;